// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".checkout-bottom-navigation[data-v-39d3834a]{position:fixed;bottom:0;left:0;width:100%;background:#fff}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
